import { render } from "./Facturas.vue?vue&type=template&id=67fc0b1a&scoped=true"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"

import "./Facturas.vue?vue&type=style&index=0&id=67fc0b1a&scoped=true&lang=css"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fc0b1a"]])

export default __exports__